import React, {Component} from "react";
import {Formik, Form, Field} from "formik";
import "react-datepicker/dist/react-datepicker.css";
import {utils} from "~/utils";


class ScratchPOForm extends Component {
    constructor(props) {
        super(props);
        this.formik = React.createRef();
        this.init_values = {
            spo: this.props.run.scratch_po.spo,
            job: this.props.run.scratch_po.job,
            svo: this.props.run.scratch_po.svo,
            total_value: this.props.run.scratch_po.total_value,
            currency: this.props.run.scratch_po.currency,
            vendor: this.props.run.scratch_po.vendor,
            goods_receipt: this.props.run.scratch_po.goods_receipt,
            goods_receipt_approval: utils.renderDate(this.props.run.scratch_po.goods_receipt_approval)
        }
    }

    static header = (
        <nav className="navbar">
            <span className="navbar-brand h4">Scratch PO</span>
        </nav>
    );


    render() {
        const init_values = {...this.props.run.scratch_po}
        console.log(init_values)
        return (
            <div>
                <div className="content">
                    <Formik ref={this.formik}
                        initialValues={init_values}
                        enableReinitialize={true}>
                        {formik => (
                            <Form>
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <label>JOB ID</label>
                                        <Field
                                            name="job"
                                            type="text"
                                            min={0}
                                            disabled={true}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <label>SPO</label>
                                        <Field
                                            name="spo"
                                            type="text"
                                            disabled={true}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>SVO</label>
                                            <Field
                                                name="svo"
                                                type="text"
                                                disabled={true}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Vendor</label>
                                            <Field
                                                name="vendor"
                                                type="text"
                                                disabled={true}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Total Value</label>
                                            <Field
                                                name="total_value"
                                                type="text"
                                                disabled={true}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Currency</label>
                                            <Field
                                                name="currency"
                                                type="text"
                                                disabled={true}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Good receipt</label>
                                            <Field
                                                name="goods_receipt"
                                                type="text"
                                                disabled={true}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Good receipt approval</label>
                                            <Field
                                                name="goods_receipt_approval"
                                                type="text"
                                                disabled={true}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        );
    }
}

export default ScratchPOForm;
